/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteRouteImport } from './routes/_authed/route'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CookiesPolicyRouteImport } from './routes/cookies-policy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedAccountRouteImport } from './routes/_authed/account'
import { Route as AuthedConsortiumRouteImport } from './routes/_authed/consortium'
import { Route as AuthedImportRouteImport } from './routes/_authed/import'
import { Route as AuthedParcelsRouteImport } from './routes/_authed/parcels'
import { Route as AuthedResumeRouteImport } from './routes/_authed/resume'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesPolicyRoute = CookiesPolicyRouteImport.update({
  id: '/cookies-policy',
  path: '/cookies-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAccountRoute = AuthedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedConsortiumRoute = AuthedConsortiumRouteImport.update({
  id: '/consortium',
  path: '/consortium',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedImportRoute = AuthedImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedParcelsRoute = AuthedParcelsRouteImport.update({
  id: '/parcels',
  path: '/parcels',
  getParentRoute: () => AuthedRouteRoute,
} as any)
const AuthedResumeRoute = AuthedResumeRouteImport.update({
  id: '/resume',
  path: '/resume',
  getParentRoute: () => AuthedRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact-us': typeof ContactUsRoute
  '/cookies-policy': typeof CookiesPolicyRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthedAccountRoute
  '/consortium': typeof AuthedConsortiumRoute
  '/import': typeof AuthedImportRoute
  '/parcels': typeof AuthedParcelsRoute
  '/resume': typeof AuthedResumeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact-us': typeof ContactUsRoute
  '/cookies-policy': typeof CookiesPolicyRoute
  '/login': typeof LoginRoute
  '/account': typeof AuthedAccountRoute
  '/consortium': typeof AuthedConsortiumRoute
  '/import': typeof AuthedImportRoute
  '/parcels': typeof AuthedParcelsRoute
  '/resume': typeof AuthedResumeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteRouteWithChildren
  '/contact-us': typeof ContactUsRoute
  '/cookies-policy': typeof CookiesPolicyRoute
  '/login': typeof LoginRoute
  '/_authed/account': typeof AuthedAccountRoute
  '/_authed/consortium': typeof AuthedConsortiumRoute
  '/_authed/import': typeof AuthedImportRoute
  '/_authed/parcels': typeof AuthedParcelsRoute
  '/_authed/resume': typeof AuthedResumeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact-us'
    | '/cookies-policy'
    | '/login'
    | '/account'
    | '/consortium'
    | '/import'
    | '/parcels'
    | '/resume'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact-us'
    | '/cookies-policy'
    | '/login'
    | '/account'
    | '/consortium'
    | '/import'
    | '/parcels'
    | '/resume'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/contact-us'
    | '/cookies-policy'
    | '/login'
    | '/_authed/account'
    | '/_authed/consortium'
    | '/_authed/import'
    | '/_authed/parcels'
    | '/_authed/resume'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren
  ContactUsRoute: typeof ContactUsRoute
  CookiesPolicyRoute: typeof CookiesPolicyRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies-policy': {
      id: '/cookies-policy'
      path: '/cookies-policy'
      fullPath: '/cookies-policy'
      preLoaderRoute: typeof CookiesPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/account': {
      id: '/_authed/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthedAccountRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/consortium': {
      id: '/_authed/consortium'
      path: '/consortium'
      fullPath: '/consortium'
      preLoaderRoute: typeof AuthedConsortiumRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/import': {
      id: '/_authed/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AuthedImportRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/parcels': {
      id: '/_authed/parcels'
      path: '/parcels'
      fullPath: '/parcels'
      preLoaderRoute: typeof AuthedParcelsRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
    '/_authed/resume': {
      id: '/_authed/resume'
      path: '/resume'
      fullPath: '/resume'
      preLoaderRoute: typeof AuthedResumeRouteImport
      parentRoute: typeof AuthedRouteRoute
    }
  }
}

interface AuthedRouteRouteChildren {
  AuthedAccountRoute: typeof AuthedAccountRoute
  AuthedConsortiumRoute: typeof AuthedConsortiumRoute
  AuthedImportRoute: typeof AuthedImportRoute
  AuthedParcelsRoute: typeof AuthedParcelsRoute
  AuthedResumeRoute: typeof AuthedResumeRoute
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedAccountRoute: AuthedAccountRoute,
  AuthedConsortiumRoute: AuthedConsortiumRoute,
  AuthedImportRoute: AuthedImportRoute,
  AuthedParcelsRoute: AuthedParcelsRoute,
  AuthedResumeRoute: AuthedResumeRoute,
}

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  ContactUsRoute: ContactUsRoute,
  CookiesPolicyRoute: CookiesPolicyRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
